import { render, staticRenderFns } from "./AddSCPage.vue?vue&type=template&id=17880997&"
import script from "./AddSCPage.vue?vue&type=script&lang=js&"
export * from "./AddSCPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports